// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"b6db82dc","297":"2f90820e","643":"7a31d9e5"}[chunkId] + ".chunk.js";
};